import { render } from "./WhereUsedPanel.vue?vue&type=template&id=0970d469&scoped=true"
import script from "./WhereUsedPanel.vue?vue&type=script&lang=js"
export * from "./WhereUsedPanel.vue?vue&type=script&lang=js"

import "./WhereUsedPanel.vue?vue&type=style&index=0&id=0970d469&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0970d469"]])

export default __exports__